import {Icon, Modal, Spin} from 'antd';
import moment from 'moment';
import React from 'react';
import {Query} from 'react-apollo';
import {GET_ORDERS} from '../../../../graphql';
import {getIntoObject} from '../../../../helpers';
import {Order} from '../../../../interfaces';

interface Properties {
  isOpen: boolean;
  closeModal: () => void;
  regionId: string;
  filter: string;
}

class ExportModal extends React.PureComponent<Properties> {
  export(data: Array<Order>) {
    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent +=
      `Date,Time,Used For testing,Merchant transaction ID,Prospect ID,Member ID,Email,Phone,Country,Club,` +
      `Membership Title,Membership Code,Starterpack Title,Starterpack Code,Promo Code,step,` +
      `utm_campaign,utm_content,utm_medium,utm_source,ospleadFinishSale_URL,` +
      `Payment Gateway Notif Success,Current month,Deposit,Joining Pack,` +
      `Total,Monthly Fee,Finished (Y/N),Person Source,Error (Y/N),Error Detail \r\n`;

    let currentMonthTotal = 0;
    let joiningPackTotal = 0;
    let total = 0;
    let futurePayments = 0;

    data
      .filter((o: Order) => o.order.history)
      .forEach(function(x: any) {
        const {order} = x;
        const date: Date = Number(x.createdAt) ? new Date(Number(x.createdAt)) : new Date(x.createdAt);

        const paymentSuccessed = order.history.some((i: any) => i.message === 'Payment gateway notification successed');

        const errors = order.history.reduce((acc: any, e: any) => {
          if (e.err && (e.type === 'error' || e.type === undefined)) {
            // undefined because of history
            acc.push(e.message);
          }
          return acc;
        }, []);

        let row =
          `${moment(date).format('YYYY-MM-DD')},${moment(date).format('HH:mm')},` +
          `${getIntoObject(order, ['isTesting'], 'false')},` +
          `${getIntoObject(order, ['merchantTransactionId'], '')},` +
          `${getIntoObject(order, ['prospect', 'prospectId'], '')},` +
          `${getIntoObject(order, ['prospect', 'personExternalId'], '')},` +
          `${getIntoObject(order, ['person', 'email'], '')},` +
          `${getIntoObject(order, ['person', 'mobile'], '')},` +
          `${getIntoObject(order, ['person', 'country'], '')},` +
          `${getIntoObject(order, ['currentClub', 'name'], '')},` +
          `${getIntoObject(order, ['currentMembership', 'title'], '')},` +
          `${getIntoObject(order, ['currentMembership', 'externalId'], '')},` +
          `${getIntoObject(order, ['currentStarterpack', 'title'], '')},` +
          `${getIntoObject(order, ['currentStarterpack', 'externalId'], '')},` +
          `${getIntoObject(order, ['contract', 'promoCode'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'step'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'utm_campaign'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'utm_content'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'utm_medium'], '')},` +
          `${getIntoObject(order, ['salesProcessQueryParamsObject', 'utm_source'], '')},` +
          `${getIntoObject(order, ['orderRessurectionLink'], '')},` +
          `${paymentSuccessed ? 'Y' : 'N'},` +
          `${getIntoObject(order, ['contract', 'price', 'proRataPrice'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'deposit'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'joiningFeePrice'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'totalAmount'], '')},` +
          `${getIntoObject(order, ['contract', 'price', 'normalPeriodPrice'], '')},` +
          `${order.finished ? 'Y' : 'N'},` +
          `${getIntoObject(order, ['source'], '') === 'dsp' ? 'DSP' : 'OSP'},` +
          `${errors && Array.isArray(errors) && errors.length > 0 ? 'Y' : 'N'},` +
          `${errors && Array.isArray(errors) && errors.join('; ')}`;

        csvContent += `${row}\r\n`;

        if (paymentSuccessed && moment(date).isSame(moment(), 'day')) {
          currentMonthTotal += Number(getIntoObject(order, ['contract', 'price', 'proRataPrice'], ''));
          joiningPackTotal += Number(getIntoObject(order, ['contract', 'price', 'joiningFeePrice'], ''));
          total += Number(getIntoObject(order, ['contract', 'price', 'totalAmount'], ''));
          futurePayments += Number(getIntoObject(order, ['contract', 'price', 'normalPeriodPrice'], ''));
        }
      });

    csvContent += ``;
    csvContent += `Total dues today,Current month,Joining Pack,Total,Future payments\r\n`;
    csvContent += `,${currentMonthTotal},${joiningPackTotal},${total},${futurePayments}`;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', `sales-export-${moment().format('YYYY-MM-DD')},${moment().format('HHmm')}.csv`);
    document.body.appendChild(link); // Required for FF
    link.click();
    this.props.closeModal();
  }

  render() {
    const {regionId, closeModal, isOpen, filter} = this.props;
    return (
      <Modal title="Export CSV Modal" visible={isOpen} onCancel={closeModal} destroyOnClose okButtonProps={{style: {display: 'none'}}}>
        <Query query={GET_ORDERS} variables={{regionId, filter}}>
          {({loading, error, data: {orders}}: any) => {
            if (loading) {
              const icon = <Icon type="loading" style={{fontSize: 24, marginRight: 10}} spin />;
              return (
                <div>
                  <Spin indicator={icon} />
                  Preparing Data for CSV...
                </div>
              );
            }
            if (error) {
              return `Error! ${error.message}`;
            }

            this.export(orders.orders);
            return <div>Data are ready for export</div>;
          }}
        </Query>
      </Modal>
    );
  }
}

export default ExportModal;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/ExportModal.tsx